import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography, Button, Card } from 'antd';

const { Text, Title } = Typography;

const PlanDetails = ({ plan }) => {
  return (
    <>
      <Card size="small" title="Basic Information">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={2}>{plan.title || 'Untitled Plan'}</Title>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div style={{ width: '100%', overflow: 'hidden' }}>
              <img
                src={plan.image}
                alt={`main view`}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '600px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </Col>
          <Col span={24}>
            <Text strong>Description: </Text> {plan.description || 'No description'}
          </Col>
          <Col span={24}>
            {plan.url ? (
              <Button
                type="primary"
                style={{ minWidth: '200px' }}
                onClick={() => window.open(plan.url, '_blank')}
              >
                {plan.url.indexOf('configurator') > 0 ? 'Configurator' : 'Open URL'}
              </Button>
            ) : (
              'N/A'
            )}
          </Col>
          <Col span={24}>
            {plan.decorId ? (
              <Button
                type="primary"
                style={{ minWidth: '200px' }}
                onClick={() =>
                  window.open(`https://3d.homewip.com/#!/product/${plan.decorId}`, '_blank')
                }
              >
                Decor
              </Button>
            ) : (
              'N/A'
            )}
          </Col>
          <Col span={24}>
            {plan.planId ? (
              <Button
                type="primary"
                style={{ minWidth: '200px' }}
                onClick={() =>
                  window.open(`https://3d.homewip.com/#!/product/${plan.planId}`, '_blank')
                }
              >
                Plan
              </Button>
            ) : (
              'N/A'
            )}
          </Col>
        </Row>
      </Card>

      <Card size="small" title="Plan Properties" style={{ marginTop: '16px' }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Text strong>Is Hidden: </Text> {plan.isHidden ? 'Yes' : 'No'}
          </Col>
          <Col span={24}>
            <Text strong>Has AR Model: </Text> {plan.hasARModel ? 'Yes' : 'No'}
          </Col>
          <Col span={24}>
            <Text strong>AR Model Link: </Text> {plan.arModelLink || 'N/A'}
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
          <Col span={24}>
            <Text strong>Is Modular: </Text> {plan.isModular ? 'Yes' : 'No'}
          </Col>
          <Col span={24}>
            <Text strong>Is Manufactured: </Text> {plan.isManufactured ? 'Yes' : 'No'}
          </Col>
          <Col span={24}>
            <Text strong>Pre Approved: </Text> {plan.preApproved ? 'Yes' : 'No'}
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
          <Col span={24}>
            <Text strong>Fix Price: </Text> ${plan.fixPrice || 0}
          </Col>
          <Col span={24}>
            <Text strong>Plan Cost: </Text> ${plan.planCost || 0}
          </Col>
        </Row>
      </Card>
    </>
  );
};

PlanDetails.propTypes = {
  plan: PropTypes.shape({
    description: PropTypes.string,
    url: PropTypes.string,
    planCost: PropTypes.number,
    isHidden: PropTypes.bool,
    hasARModel: PropTypes.bool,
    arModelLink: PropTypes.string,
    isModular: PropTypes.bool,
    isManufactured: PropTypes.bool,
    preApproved: PropTypes.bool,
    fixPrice: PropTypes.number
  }).isRequired
};

export default PlanDetails;
